import React from 'react'
import { FaBars, FaDiscord, FaTwitter } from 'react-icons/fa'
import { FootIcon, Socials, Foot } from './FootElements'

const Footer = () => {
    return (
        <Foot>
            <Socials>

                <FootIcon href="https://twitter.com/magic_mushies">
                    <FaTwitter/>
                </FootIcon>
                <FootIcon href="http://discord.gg/QT8TX7QDt2">
                    <FaDiscord/>
                </FootIcon>
            </Socials>

        </Foot>
    )
}

export default Footer
